export default __webpack_public_path__ + "a94fcd11723a7d3bd8f977b04c5c5e33.png";